var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "availability_input",
      staticClass: "offcanvas offcanvas-right offcanvas-xl",
      attrs: { id: "availability_input" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "availability_input_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#", id: "availability_input_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("availability_input")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-arrow-left" })]
          ),
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("availabilityInput.title")) + " "),
          ]),
          _c("div"),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        _vm._l(_vm.workingHours, function (dailyWorkingHours, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "daily-working-hours",
              class: key === "sunday" ? "mb-14" : "",
            },
            [
              _c(
                "div",
                { staticClass: "daily-working-hours-switch" },
                [
                  _c("BBSwitch", {
                    attrs: { label: _vm.$t("weekdays." + key) },
                    model: {
                      value: dailyWorkingHours.on,
                      callback: function ($$v) {
                        _vm.$set(dailyWorkingHours, "on", $$v)
                      },
                      expression: "dailyWorkingHours.on",
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !dailyWorkingHours.on,
                          expression: "!dailyWorkingHours.on",
                        },
                      ],
                      staticClass: "mobile-daily-working-hours-closed",
                    },
                    [_vm._v(_vm._s(_vm.$t("availabilityInput.closedLabel")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: dailyWorkingHours.on,
                      expression: "dailyWorkingHours.on",
                    },
                  ],
                  staticClass: "daily-working-hours-selects",
                },
                [
                  _vm._l(dailyWorkingHours.hours, function (time, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "daily-working-hours-select" },
                      [
                        _c("BBSelect", {
                          attrs: {
                            options: _vm.getTimeOptions(key),
                            placeholderHidden: true,
                          },
                          model: {
                            value: time.from,
                            callback: function ($$v) {
                              _vm.$set(time, "from", $$v)
                            },
                            expression: "time.from",
                          },
                        }),
                        _c("span", [_vm._v(" - ")]),
                        _c("BBSelect", {
                          attrs: {
                            options: _vm.getTimeOptions(key, time.from),
                            placeholderHidden: true,
                          },
                          model: {
                            value: time.to,
                            callback: function ($$v) {
                              _vm.$set(time, "to", $$v)
                            },
                            expression: "time.to",
                          },
                        }),
                        index === 0
                          ? _c("div", { staticStyle: { width: "22px" } })
                          : _vm._e(),
                        index !== 0
                          ? _c(
                              "button",
                              {
                                staticClass: "daily-working-hours-remove-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeHoursForDay(key, index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "feather feather-x",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "12",
                                      height: "12",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "#99ACC2",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("line", {
                                      attrs: {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18",
                                      },
                                    }),
                                    _c("line", {
                                      attrs: {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "daily-working-hours-add-btn",
                      on: {
                        click: function ($event) {
                          return _vm.addHoursForDay(key)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("availabilityInput.addBtn")))]
                  ),
                ],
                2
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !dailyWorkingHours.on,
                      expression: "!dailyWorkingHours.on",
                    },
                  ],
                  staticClass: "daily-working-hours-closed",
                },
                [_vm._v(_vm._s(_vm.$t("availabilityInput.closedLabel")))]
              ),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "button",
          { staticClass: "bb-btn btn-success", on: { click: _vm.save } },
          [_vm._v(" " + _vm._s(_vm.$t("availabilityInput.saveBtn")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }